import { LocationAssociation } from '@kinetic-ui/data-layer';
import { recoilKeys } from 'const';
import { atom, useRecoilState } from 'recoil';

export const associatedEntitiesState = atom<LocationAssociation[] | undefined>({
  key: recoilKeys.ASSOCIATED_ENTITIES,
  default: [],
});
export const useAssociatedEntities = () => {
  const [associatedEntities, setAssociatedEntities] = useRecoilState(associatedEntitiesState);

  return { associatedEntities, setAssociatedEntities };
};
